// extracted by mini-css-extract-plugin
export default {"root":"weeks-module___root___e4ce9307"};